import React from 'react';
import Snackbar from '@mui/material/Snackbar';

import Alert from '../Alert';
import EmailVerificationPromptModal from './EmailVerificationPromptModal';
import { useEmailVerificationPrompt } from '../../hooks/useEmailVerificationPrompt';
import { EMAIL_VERIFIED_TOAST_TITLE, getVerificationEmailAddress } from '../../utils/emailVerificationPrompt';

const TOAST_AUTO_HIDE_MS = 5000;

// Skippable "verify your email" prompt (ENG-3097, mirrors consumer web ENG-2782). Mounted once in App.js.
const EmailVerificationPrompt = () => {
    const { isOpen, isToastOpen, user, dismiss, completeVerification, closeToast } = useEmailVerificationPrompt();

    return (
        <>
            {isOpen && (
                <EmailVerificationPromptModal
                    email={getVerificationEmailAddress(user)}
                    onDismiss={dismiss}
                    onVerified={completeVerification}
                    data-testid="modal.email-verification-prompt"
                />
            )}
            <Snackbar
                open={isToastOpen}
                autoHideDuration={TOAST_AUTO_HIDE_MS}
                onClose={closeToast}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={closeToast} severity="success" sx={{ width: '100%' }} data-testid="toast.email-verified">
                    {EMAIL_VERIFIED_TOAST_TITLE}
                </Alert>
            </Snackbar>
        </>
    );
};

export default EmailVerificationPrompt;
